import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noServices: {
    defaultMessage: 'No services selected',
    description: 'text indicating that the user does not have any services selected',
    id: 'SltMYT',
  },
  servicesVisibleText: {
    defaultMessage: '{numberOfVisibleServices} of {numberOfServices, plural, one {# service} other {# services}}',
    description: 'selected services count',
    id: '/VbXfg',
  },
});

export default messages;
